// src/components/modals/ConfirmationModal.tsx
import React from 'react';
import { styled } from '../../styles/stitches.config';
import { ActionButton } from '../../styles/profile/profile.style';
import { ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '../../styles/messenger/messenger.style';


interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Delete',
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter>
          <ActionButton type="button" intent="secondary" onClick={onClose}>
            Cancel
          </ActionButton>
          <ActionButton type="button" intent="danger" onClick={onConfirm}>
            {confirmText}
          </ActionButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};